import React from 'react';
import { Card, CardContent, Typography, Box, Chip } from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import { Appointment } from '../../../../types';
import { dayjs } from '../../../../utils/dayjs-config';

interface BlockerCardProps {
  blocker: Appointment;
}

const BlockerCard: React.FC<BlockerCardProps> = ({ blocker }) => {
  const title = blocker.notes || blocker.appointmentTitle || 'Unavailable';
  const start = dayjs(`${blocker.appointmentDate}${blocker.appointmentTime}`, 'MMDDYYYYHHmm');
  const end = start.add(blocker.appointmentDuration, 'minute');

  return (
    <Card
      sx={{
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'grey.300',
        backgroundColor: 'grey.100',
      }}
    >
      <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <BlockIcon color="action" />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            Time
          </Typography>
          <Typography variant="body1">
            {start.format('dddd, MMM D | h:mma')} – {end.format('h:mma')}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            Staff
          </Typography>
          <Typography variant="body1">{blocker.employeeName}</Typography>
        </Box>
        <Chip
          label="Unavailable"
          size="small"
          color="warning"
          sx={{ alignSelf: 'flex-start', fontWeight: 600 }}
        />
      </CardContent>
    </Card>
  );
};

export default BlockerCard;
